import { render, staticRenderFns } from "./SelfRegistration.vue?vue&type=template&id=459c8ca0&"
import script from "./SelfRegistration.vue?vue&type=script&lang=js&"
export * from "./SelfRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports